import React from "react";
import { Box } from "@mui/material";
import { CasLogo } from "../../brand/CasLogo";

// One row on Cas's side of the thread, laid out like an SMS conversation:
// a fixed 44px avatar column (U.11), then the content. The avatar sits at the bottom
// of the row and is drawn only on the LAST row of a consecutive run of Cas
// rows (the SMS convention), so a burst of messages/tool calls shares one
// portrait. Rows without it keep the empty column so everything stays aligned.

export const CAS_AVATAR_SIZE = 44;

interface AgentRowProps {
  showAvatar: boolean;
  children: React.ReactNode;
}

export const AgentRow: React.FC<AgentRowProps> = ({ showAvatar, children }) => (
  <Box
    data-testid="agent-row"
    sx={{
      display: "flex",
      alignItems: "flex-end",
      gap: 1,
      alignSelf: "stretch",
      minWidth: 0,
    }}
  >
    <Box sx={{ width: CAS_AVATAR_SIZE, flexShrink: 0, display: "flex" }}>
      {showAvatar && (
        <CasLogo
          size={CAS_AVATAR_SIZE}
          data-testid="cas-avatar"
          sx={{ borderRadius: "50%" }}
        />
      )}
    </Box>
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      {children}
    </Box>
  </Box>
);
